import React from "react";
import DetailsSectionHeaderActions from "internal/programs/migration-acceleration-program/2024/fund-request/components/details/sections/header/DetailsSectionHeaderActions";
import { getFundRequestId } from "internal/util/helper";
import { IDetailsProps } from "shared/programs/migration-acceleration-program/2024/fund-request/types/SchemaTypes";
import ProjectDetailsDetailContainer from "internal/programs/migration-acceleration-program/2024/fund-request/components/details/sections/project-details/ProjectDetails";

const ProjectDetailsContainer = ({ ...props }: IDetailsProps) => {
  const visible = true;
  return (
    <ProjectDetailsDetailContainer
      {...props}
      actions={
        <DetailsSectionHeaderActions
          visible={visible}
          editPath={`/map2024/${getFundRequestId()}/project-details/edit`}
        />
      }
    />
  );
};

export default ProjectDetailsContainer;
